<template>
  <el-dialog
    top="50px"
    width="400px"
    title="Thêm đối tượng liên kết"
    :visible="visible"
    :show-close="!callingAPI"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('close')"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="{}"
      :show-message="true"
      size="medium"
      label-position="top"
    >
      <el-row
        type="flex"
        align="start"
        class="flex-wrap"
        :gutter="12"
      >
        <el-col
:lg="24"
:span="24">
          <el-form-item
prop="object"
label="Đối tượng liên kết">
            <el-select
              v-model="form.object"
              class="w-100"
              placeholder=""
              disabled
            >
              <el-option
                v-for="c in allConfigs"
                :key="c.id"
                :label="c.extra.name"
                :value="c.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
:lg="24"
:span="24">
          <el-form-item
prop="items"
label="Danh sách">
            <el-select
              v-model="form.items"
              :placeholder="`Chọn ${object.extra.name}`"
              class="w-100"
              multiple
              filterable
              :disabled="callingAPI"
              :loading="loading"
              remote
              :remote-method="remoteMethod"
            >
              <el-option
                v-for="op in listItems"
                :key="op.id"
                :label="op.extra.name"
                :value="op.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
slot="footer"
class="dialog-footer">
      <el-button
:disabled="callingAPI"
size="medium"
@click="$emit('close')">
        Đóng
      </el-button>
      <el-button
        type="primary"
        :disabled="form.items.length <= 0"
        :loading="callingAPI"
        size="medium"
        @click="handleConfirm"
      >
        Lưu
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import commonServices from "@/services/common";
import organizationServices from "@/services/organization"
import { notification, convertPayloadData } from "@/utils/common";

export default {
  name: "ConnectionFormPopup",
  props: {
    item: Object,
    config: Object,
    object: Object,
    visible: Boolean,
    itemRelations: Array,
  },
  data() {
    return {
      loading: false,
      searchText: "",
      searchTimeout: null,
      listItems: [],
      form: {
        object: this.object.id,
        items: [],
      },
      callingAPI: false,
      organizationId: organizationServices.getCurrentOrg()?.id
    };
  },
  computed: {
    ...mapGetters("config", ["allConfigs"]),
    itemRelationIds() {
      return this.itemRelations.map((r) => r.item_id).filter(Boolean);
    },
    params() {
      const _params = {
        offset: 0,
        limit: 20,
        locale: "vi",
      };
      _params.filters = {
        type: this.object?.extra?.key,
        organization_id: this.organizationId,
      };
      if (this.searchText?.trim()) {
        _params.filters["extra.name"] = { $regex: this.searchText?.trim() };
      }
      return _params;
    },
  },
  beforeMount() {
    this.listData();
  },
  methods: {
    listData() {
      this.loading = true;
      commonServices
        .list(this.object.type, this.params)
        .then((response) => {
          const currentItemIds = this.listItems.map((i) => i.id);
          const newItems = response.items.filter(
            (i) =>
              !this.itemRelationIds.includes(i.id) &&
              i.id !== this.item.id &&
              !currentItemIds.includes(i.id)
          );
          this.listItems = [...this.listItems, ...newItems];
          this.loading = false;
        })
        .catch(() => {
          this.data = [];
          this.loading = false;
        });
    },
    remoteMethod(query) {
      if (!this.searchTimeout) {
        this.searchTimeout = setTimeout(() => {
          this.searchText = query;
          this.listData();
        }, 300);
      } else {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = null;
      }
    },
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.callingAPI = true;
          commonServices
            .update(
              this.config.type,
              convertPayloadData(this.item.type, {
                ...this.item,
                extra: {
                  ...this.item.extra,
                  relations: [
                    ...this.itemRelations,
                    ...this.form.items.map((id, index) => ({
                      item_id: id,
                      order: this.itemRelations.length + index + 1,
                    })),
                  ],
                },
              })
            )
            .then(async () => {
              notification(
                this,
                "success",
                "update",
                `${this.item.extra.name}`
              );
              this.callingAPI = false;
              await this.handleUpdateRelationItems();
              this.$emit("reload");
              this.$emit("close");
            })
            .catch(() => {
              this.callingAPI = false;
              notification(this, "error", "update", `${this.item.extra.name}`);
            });
        }
      });
    },
    async handleUpdateRelationItems() {
      try {
        const relationItems = this.listItems.filter((i) =>
          this.form.items.includes(i.id)
        );
        const requests = relationItems.map((rItem) => {
          const relations =
            rItem.extra?.relations?.filter(
              (r) => r.item_id !== this.item?.id
            ) || [];
          return commonServices.update(
            this.object.type,
            convertPayloadData(this.object.extra?.key, {
              ...rItem,
              extra: {
                ...rItem.extra,
                relations: [
                  ...relations,
                  {
                    item_id: this.item?.id,
                    order: relations.length + 1,
                  },
                ],
              },
            })
          );
        });
        await Promise.all(requests);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
